import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  DashFoldersRoute,
  DashFolderPathName,
} from '@/modules/ta/dashfolders/dashfolders.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${DashFoldersRoute.DASHFOLDERS}/:id`,
      name: DashFolderPathName.DASHFOLDERS,
      component: () =>
        import(/* webpackChunkName: "dash-folders-list-page" */ './pages/DashFoldersListPage.vue'),
      props: true,
    },
  ],
  Module.DASHFOLDERS
);
